import { render, staticRenderFns } from "./UpgraderFilterSort.vue?vue&type=template&id=68c9b0bc&scoped=true"
import script from "./UpgraderFilterSort.vue?vue&type=script&lang=js"
export * from "./UpgraderFilterSort.vue?vue&type=script&lang=js"
import style0 from "./UpgraderFilterSort.vue?vue&type=style&index=0&id=68c9b0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c9b0bc",
  null
  
)

export default component.exports